import { useState } from 'react';

const faqs = [
  { id: 1, q: '爱丫爱丫影院真的完全免费吗？', a: '是的，爱丫爱丫影院对所有用户永久免费开放，无需注册、无需付费、无需会员。你可以随时打开网站观看任何影片，不存在任何隐藏收费。' },
  { id: 2, q: '播放会卡顿或缓冲吗？', a: '我们的播放引擎经过深度优化，采用多 CDN 加速和智能码率适配技术。在正常网络环境下，影片可以做到秒开播放，全程流畅不卡顿。即使网络波动，系统也会自动调节画质以确保播放连续性。' },
  { id: 3, q: '支持哪些设备观看？', a: '爱丫爱丫影院支持所有主流设备，包括 Windows/Mac 电脑、iPhone/Android 手机、iPad/安卓平板等。无需下载任何 App，通过浏览器即可访问，界面自动适配不同屏幕尺寸。' },
  { id: 4, q: '影片画质如何？有高清吗？', a: '平台大部分影片支持全高清（1080P）播放，部分热门影片支持超清 4K 画质。系统会根据你的网络速度自动选择最佳画质，Wi-Fi 环境下默认高清播放，移动网络下智能优化流畅度。' },
  { id: 5, q: '片源更新速度快吗？新上映的电影多久能看？', a: '我们拥有专业的内容更新团队，每日更新 50+ 部影片。热门电影通常在院线下映后 1-3 个月内上线，热门电视剧当天或次日即可同步更新，确保你不会错过精彩内容。' },
];

export default function SectionFAQ() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 text-center mb-2">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于爱丫爱丫影院，你可能想了解的</p>
        <div className="space-y-3">
          {faqs.map((faq) => (
            <div key={faq.id} className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
              >
                <h3 className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</h3>
                <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 flex-shrink-0 ${openId === faq.id ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </span>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}